const LHT_DELIMITER = '%%LHT%%';

export function replaceLHTWithSrOnlyHTML(input: string): string {
  const regex = new RegExp(`${LHT_DELIMITER}([\\s\\S]*?)${LHT_DELIMITER}`, 'g');

  return input.replace(regex, (_match, lhtContent) => {
    return `<span class="sr-only">${lhtContent}</span>`;
  });
}
